import { ceil, floor } from '@utils/number';

if (typeof window !== 'undefined') {
    window.ceil = ceil;
    window.floor = floor;
}
